import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
    server: {
        /** NEXT Auth */
        NEXTAUTH_URL: z.string().min(1),
        NEXTAUTH_SECRET: z.string().min(1),
        DEBUG_ENABLED: z.enum(['true', 'false']),

        /** IFA Backend */
        IFA_BACKEND_URL: z.string().url(),

        /** AWS
         * Prefixed with IFA so that pipeline or personal user credentials aren't used by accident
         */
        IFA_AWS_ACCESS_KEY_ID: z.string().min(1),
        IFA_AWS_SECRET_ACCESS_KEY: z.string().min(1),
    },
    client: {
        NEXT_PUBLIC_APP_VERSION: z.string().min(1),
    },
    // For Next.js >= 13.4.4, you only need to destructure client variables:
    experimental__runtimeEnv: {
        NEXT_PUBLIC_APP_VERSION: process.env.NEXT_PUBLIC_APP_VERSION,
    },
});
